export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const DEFAULT_LOCALE = 'en';
export const LOCAL_STORAGE_LOCALE_KEY = 'alva:locale';
export const AVAILABLE_LOCALES = ['en', 'sv'];
export const AVAILABLE_LOCALE_NAMES: {[key: string]: string} = {
    'en': 'English',
    'sv': 'Svenska'
};
